import { render, staticRenderFns } from "./ModalFailed.vue?vue&type=template&id=a7ffa516&"
import script from "./ModalFailed.vue?vue&type=script&lang=js&"
export * from "./ModalFailed.vue?vue&type=script&lang=js&"
import style0 from "./ModalFailed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports